import { LoggerService } from './../logger/logger.service';
import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, NgZone } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class ScriptInjectorService
{

	constructor(
    @Inject(DOCUMENT) private readonly document: Document,
    private readonly zone: NgZone,
    private readonly loggerService: LoggerService
	){}

	public async load(id: string, src: string): Promise<void>
	{
		const scriptElement: HTMLScriptElement = this.buildScriptElement(id, src);
		const responsePromise: Promise<void> = this.addEventListenersToScriptElement(scriptElement);
		this.addScriptElementToDocument(scriptElement);
		return responsePromise;
	}

	private buildScriptElement(id: string, src: string): HTMLScriptElement
	{
		const scriptElement: HTMLScriptElement = this.document.createElement(
			'script'
		);
		scriptElement.id = id;
		scriptElement.src = src;
		scriptElement.async = true;
		return scriptElement;
	}

	private addEventListenersToScriptElement(scriptElement: HTMLScriptElement): Promise<void>
	{
		return new Promise<void>((resolve, reject) =>
		{
			scriptElement.addEventListener('load', () =>
			{
				setTimeout(resolve, 10);
			});
			scriptElement.addEventListener('error', (error) =>
			{
				reject(error);
			});
		});
	}

	private addScriptElementToDocument(scriptElement: HTMLScriptElement): void
	{
		this.zone.runOutsideAngular(() =>
		{
			const appendedScriptElement: HTMLScriptElement = this.document.head.appendChild(scriptElement);
			this.loggerService.log('ScriptInjectorService Appended Script:', appendedScriptElement);
		});
	}

}
